export const updateProducts = (products, dolares, tipoDeCambio, decimales) => {
    if (!dolares) {
        const productsArray = products.map((product) => {
            const pd = product.porcentajeDescuento ? product.porcentajeDescuento : 0;
            //const pud = fixDecimals(product.precioUnitario - product.precioUnitario * (pd / 100), 2);

            const pu = fixDecimals(product.precioUnitario, 2);
            const importe = fixDecimals(pu * product.cantidad, 2);

            const importeDescuento = fixDecimals(importe * (1 - pd / 100), 2);
            const descuento = fixDecimals(importe - importeDescuento, 2);
            return {
                ...product,
                porcentajeDescuento: pd,
                descuento: descuento,
                precioUnitarioConDescuento: pu,
                precioUnitario: pu,
                importe: importe,
                importeDescuento: importeDescuento,
                almacen: product.almacen ? product.almacen : 'Juvalfri', // cambiar segun la empresa
            }
        });
        return productsArray;
    } else {
        const productsArray = products.map((product) => {
            const pd = product.porcentajeDescuento ? product.porcentajeDescuento : 0;
            // let pud = fixDecimals((pu - pu * (pd / 100)), decimales);

            const pu = fixDecimals(product.precioUnitario / tipoDeCambio, decimales);
            const importe = fixDecimals(pu * product.cantidad, decimales);

            const importeDescuento = fixDecimals(importe * (1 - pd / 100), decimales);
            const descuento = fixDecimals(importe - importeDescuento, decimales);
            return {
                ...product,
                porcentajeDescuento: pd,
                descuento: descuento,
                precioUnitarioConDescuento: pu,
                precioUnitario: pu,
                importe: importe,
                importeDescuento: importeDescuento,
                almacen: product.almacen ? product.almacen : 'Juvalfri', // cambiar segun la empresa
            }
        });
        return productsArray;
    }
}

export const fixDecimals = (number, decimales) => {
    try {
        return Number(parseFloat(number).toFixed(decimales));
    } catch (e) {
        return Number(parseFloat(number).toFixed(6));
    }
}

export const updatePrice = (products, discount, decimales, dolares, sinIva) => {
    let subtotal = products.reduce(function (tot, arr) {
        return tot + arr.importeDescuento;
    }, 0);

    const descuento = fixDecimals(subtotal * (discount / 100), decimales);
    const subtotalConDescuento = fixDecimals(subtotal - descuento, decimales);
    const ivaValue = dolares || sinIva ? 0 : 0.16;
    const iva = fixDecimals(subtotalConDescuento * ivaValue, decimales);
    const total = fixDecimals(subtotalConDescuento + iva, decimales);

    let costoTotal = products.reduce(function (tot, arr) {
        return tot + arr.costoUnitario * arr.cantidad;
    }, 0);

    const cotizacion = {
        subtotal: subtotal,
        porcentajeDescuento: discount,
        descuento: descuento,
        subtotalConDescuento: subtotalConDescuento,
        iva: iva,
        total: total,
        costoTotal: fixDecimals(costoTotal, decimales),
    }

    return cotizacion;
}

export const usdToMxn = (price, tipoDeCambio, decimales) => {
    const precio = price * tipoDeCambio;
    const precioConDecimales = fixDecimals(precio, decimales);
    return precioConDecimales;
}

export const mxnToUsd = (price, tipoDeCambio, decimales) => {
    const precio = price / tipoDeCambio;
    const precioConDecimales = fixDecimals(precio, decimales);
    return precioConDecimales;
}

export const updateExistencias = (products, serverProducts) => {
    const productsArray = products.map((product) => {
        const remoteProduct = serverProducts.find((x) => x._id === product.id);
        if (remoteProduct) {
            return {
                ...product,
                existencias: remoteProduct.cantidad,
            }
        } else {
            return {
                ...product,
                existencias: 0,
            }
        }
    });
    return productsArray;
}

export const stockNotice = (product) => {
    const diff = Number(product.existencias) - Number(product.cantidad);
    if (product.servicio) {
        return {
            color: 'secondary.main',
            message: `Producto no listado en almacén. (${product.categoria})`,
            conflict: false,
        }
    } else if (product.almacen !== 'Juvalfri') { // cambiar segun la empresa
        return {
            color: 'primary.main',
            message: `Verificar existencias con el proveedor. (Almacén externo - ${product.almacen})`,
            conflict: false,
        }
    } else {
        if (diff < 0) {
            return {
                color: 'error.main',
                message: `No hay existencias suficientes en almacén, faltan ${diff * -1} unidades. Verificar que exista la cantidad solicitada directamente en almacén.`,
                conflict: true,
            }
        } else if (diff === 0) {
            return {
                color: 'warning.dark',
                message: `Se está cotizando justo la cantidad de existencia en almacén (${product.cantidad}/${product.existencias}), favor de verificar que exista la cantidad solicitada directamente en almacén antes de confirmar al cliente.`,
                conflict: true,
            }
        } else if (diff < 5) {
            return {
                color: 'warning.dark',
                message: `Se está cotizando muy justo con las existencias (${product.cantidad}/${product.existencias}), favor de verificar que exista la cantidad solicitada directamente en almacén antes de confirmar al cliente.`,
                conflict: true,
            }
        } else {
            return {
                color: 'success.main',
                message: `Existencias suficientes. (${product.cantidad}/${product.existencias})`,
                conflict: false,
            }
        }
    }
}

export const getProductConflicts = (products) => {
    const productsArray = products.map((product) => {
        const st = stockNotice(product);
        if (st.conflict) {
            return {
                ...product,
                stockNotice: st,
            }
        } else {
            return
        }
    });
    return productsArray.filter((x) => x !== undefined);
}